import {CheckIcon} from '@heroicons/react/24/outline';
import React, {useId, type ComponentProps} from 'react';

interface IInputCheckboxProps extends Omit<ComponentProps<'input'>, 'children'> {
  children?: React.ReactNode | (({id}: {id: string}) => React.ReactNode);
  label?: string;
}

const InputCheckbox = ({children, label, ...inputProps}: IInputCheckboxProps) => {
  const id = useId();
  return (
    <div className="flex gap-3 items-center">
      <div className="flex h-6 shrink-0 items-center">
        <div className="group grid size-4 grid-cols-1">
          <input
            id={id}
            type="checkbox"
            className="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-400 bg-white checked:border-primary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto cursor-pointer"
            onClick={e => e.stopPropagation()}
            {...inputProps}
          />
          <CheckIcon className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25" />
        </div>
      </div>
      {!!label && (
        <label htmlFor={id} className="block text-sm/6 text-gray-900 dark:text-white cursor-pointer">
          {label}
        </label>
      )}
      {typeof children === 'function' ? children?.({id}) : children}
    </div>
  );
};

export default React.memo(InputCheckbox);
